import { ColumnPattern } from "@/common/components/Table";

export const anpReportsDefaultColumns: ColumnPattern[] = [
  {
    label: 'Data inicial',
    value: 'initial_date',
  },
  {
    label: 'Data final',
    value: 'end_date',
  },
  {
    label: 'Data de efetivação',
    value: 'approved_at',
    className: 'w-64',
  },
  {
    label: 'Ações',
    value: 'actions',
    className: 'w-16',
  },
];
